module.exports = __webpack_public_path__ + "static/media/instagram.0a1e26ab.svg";